import { API_URL } from '../../../../utils/config';

export const GET_VOLTAGE_MONITOR_URL = `${API_URL}/getlogs`;
